import { render, staticRenderFns } from "./EmployeeEditTabAccount.vue?vue&type=template&id=cbb1e064&"
import script from "./EmployeeEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./EmployeeEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeEditTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports